import Keycloak from 'keycloak-js';
import { recruiterEnv } from '../config/env';

let instance: Keycloak | null = null;
let initPromise: Promise<boolean> | null = null;

/** Single Keycloak client for the SPA — do not call `new Keycloak()` elsewhere. */
export function getKeycloak(): Keycloak {
  if (!instance) {
    const { url, realm, clientId } = recruiterEnv.keycloak;
    instance = new Keycloak({ url, realm, clientId });
    // Dev-only: expose the keycloak-js instance so the e2e regression suite
    // (`scripts/e2e/dev/recruiter/home.ts`) can call `keycloak.login()` without
    // going through the SPA's Google-IdP-only LoginPage. `vite build` strips
    // the `import.meta.env.DEV` branch — this is never assigned in any
    // production-mode build (stg or prd).
    if (import.meta.env.DEV && typeof window !== 'undefined') {
      (window as unknown as { __recruiterKeycloak?: Keycloak }).__recruiterKeycloak = instance;
    }
  }
  return instance;
}

/**
 * Runs `keycloak.init` at most once per page load.
 * Safe under React StrictMode (double mount) — second mount awaits the same promise.
 */
export function ensureKeycloakInitialized(): Promise<boolean> {
  const keycloak = getKeycloak();
  if (!initPromise) {
    const { onLoad, silentCheckSsoRedirectUri } = recruiterEnv.keycloak;
    initPromise = keycloak.init({
      onLoad,
      pkceMethod: 'S256',
      checkLoginIframe: false,
      ...(onLoad === 'check-sso' && silentCheckSsoRedirectUri ? { silentCheckSsoRedirectUri } : {}),
    });
  }
  return initPromise;
}
